import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { theme } from '../styles/theme';
import Button from '../components/ui/Button';
import Card from '../components/ui/Card';

const PaymentSuccessPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('order_id');

  const containerStyles = {
    maxWidth: '600px',
    margin: '0 auto',
    padding: `${theme.spacing.xxl} ${theme.spacing.lg}`,
    minHeight: '70vh',
    textAlign: 'center',
  };

  return (
    <div style={{ backgroundColor: theme.colors.background, minHeight: '100vh' }}>
      <div style={containerStyles}>
        <Card 
          padding="xxl"
          style={{
            background: `linear-gradient(to bottom, ${theme.colors.surface} 0%, ${theme.colors.surfaceAlt} 100%)`,
            border: `1px solid ${theme.colors.borderLight}`,
            boxShadow: theme.shadows.xl,
          }}
        >
          <div style={{ 
            fontSize: '6rem', 
            marginBottom: theme.spacing.xl, 
            color: theme.colors.success,
            animation: 'scaleIn 0.5s ease-out',
          }}>
            ✓
          </div>
          <h1 style={{
            fontFamily: theme.typography.fontFamily.primary,
            fontSize: theme.typography.fontSize['4xl'],
            color: theme.colors.success,
            marginBottom: theme.spacing.lg,
            fontWeight: theme.typography.fontWeight.bold,
          }}>
            Payment Successful!
          </h1>
          <p style={{ 
            fontSize: theme.typography.fontSize.xl,
            marginBottom: theme.spacing.md,
            color: theme.colors.text,
            fontWeight: theme.typography.fontWeight.semibold,
          }}>
            Thank you for your payment.
          </p>
          {orderId && (
            <p style={{ 
              fontSize: theme.typography.fontSize.lg,
              color: theme.colors.text,
              marginBottom: theme.spacing.xl,
            }}>
              Order ID: <span style={{ color: theme.colors.primary, fontWeight: theme.typography.fontWeight.bold }}>{orderId.substring(0, 8)}...</span>
            </p>
          )}
          <p style={{ 
            fontSize: theme.typography.fontSize.lg,
            color: theme.colors.textSecondary,
            marginBottom: theme.spacing.xxl,
            lineHeight: theme.typography.lineHeight.relaxed,
          }}>
            Your order has been confirmed and will be processed soon. You will receive a confirmation email with tracking information once your order ships.
          </p>
          <div style={{ 
            display: 'flex', 
            gap: theme.spacing.lg, 
            justifyContent: 'center',
            flexWrap: 'wrap',
          }}>
            <button
              onClick={() => navigate('/')}
              style={{
                padding: `${theme.spacing.md} ${theme.spacing.xl}`,
                fontSize: theme.typography.fontSize.lg,
                fontWeight: theme.typography.fontWeight.semibold,
                fontFamily: theme.typography.fontFamily.secondary,
                background: 'transparent',
                color: theme.colors.primary,
                border: `2px solid ${theme.colors.primary}`,
                borderRadius: theme.borderRadius.lg,
                cursor: 'pointer',
                transition: 'all 0.3s ease',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = theme.colors.primary;
                e.currentTarget.style.color = '#fff';
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = theme.shadows.md;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
                e.currentTarget.style.color = theme.colors.primary;
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              Back to Home
            </button>
            <button
              onClick={() => navigate('/dashboard')}
              style={{
                padding: `${theme.spacing.md} ${theme.spacing.xl}`,
                fontSize: theme.typography.fontSize.lg,
                fontWeight: theme.typography.fontWeight.bold,
                fontFamily: theme.typography.fontFamily.secondary,
                background: `linear-gradient(135deg, ${theme.colors.cta} 0%, ${theme.colors.primaryLight} 100%)`,
                color: '#fff',
                border: 'none',
                borderRadius: theme.borderRadius.lg,
                boxShadow: '0 4px 12px rgba(204, 85, 0, 0.3)',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: theme.spacing.sm,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-3px)';
                e.currentTarget.style.boxShadow = '0 8px 20px rgba(204, 85, 0, 0.4)';
                const arrow = e.currentTarget.querySelector('.orders-arrow');
                if (arrow) arrow.style.transform = 'translateX(4px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(204, 85, 0, 0.3)';
                const arrow = e.currentTarget.querySelector('.orders-arrow');
                if (arrow) arrow.style.transform = 'translateX(0)';
              }}
            >
              <span>View My Orders</span>
              <span 
                className="orders-arrow"
                style={{
                  fontSize: '1.2rem',
                  transition: 'transform 0.3s ease',
                  display: 'inline-block',
                }}
              >
                →
              </span>
            </button>
          </div>
        </Card>
        <style>{`
          @keyframes scaleIn {
            from {
              transform: scale(0);
              opacity: 0;
            }
            to {
              transform: scale(1);
              opacity: 1;
            }
          }
        `}</style>
      </div>
    </div>
  );
};

export default PaymentSuccessPage;

